import Costs from "./Costs";
import InvoicingSettings from "./InvoicingSettings";

export default {
  COSTS: Costs,
  INVOICING: InvoicingSettings,
};
